import CoreBadgeButton from './CoreBadgeButton';
import CoreBadgeButtonContainer from './CoreBadgeButton.container';
export default CoreBadgeButtonContainer(CoreBadgeButton);
//# sourceMappingURL=index.js.map